declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}

const SITE_KEY="6LevD7QaAAAAAFYxOva1w0irHASYq43Ww64IOkjl";

const loadScriptByURL = (id: string, url: string, callback?: () => void) => {
  const isScriptExist = document.getElementById(id);

  if (!isScriptExist) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.id = id;
    script.onload = function () {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }

  if (isScriptExist && callback) callback();
}

const load = () => {
  // load the script by passing the URL
  loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`);
};

const remove = () => {
  const nodeBadge = document.querySelector('.grecaptcha-badge');
    if (nodeBadge) {
      document.body.removeChild(nodeBadge.parentNode!);
    }

    const scriptSelector = 'script[src=\'https://www.google.com/recaptcha/api.js?render=' +
    SITE_KEY + '\']';
    const script = document.querySelector(scriptSelector);
    if (script) {
      script.remove();
    }
};

const ready = (callback: () => void) => {
  window.grecaptcha.ready(callback)
};

const execute = (options: { action: string }): Promise<string> => {
  return window.grecaptcha.execute(SITE_KEY, options)
};

const toExport = {
  load,
  remove,
  ready,
  execute,
};

export default toExport;
